import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Col, Container, Row } from 'reactstrap';
import { getPropertyByKey } from '../../../../api/Property';
import { useFetch } from '../../../../hooks/useFetch';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import { LoadingDisplay } from '../../../common/LoadingOverlay';
import '../../../../styles/AskPage.css';
import IconButton from '../../../common/form/IconButton';
import AskIcon from '../../../../images/faq-nav-icon.png';
import PhoneIcon from '../../../../images/phone_icon.png';
import EmailIcon from '../../../../images/email_icon.png';
import { browserHistory } from '../../../../utilities/history';
import { prospectPages, prospectPath } from '../ProspectRouter';
import { formatPhoneNumber } from '../../../../utilities/Utils';
import { tour24HelpEmail, tour24PhoneNumber } from '../../../../data/constants';

export interface Props extends RouteComponentProps<{ propertySlug: string }> {}

const AskPage = (props: Props) => {
    const {
        data: propertyData,
        error: errorMessage,
        loading: isLoading
    } = useFetch(() => getPropertyByKey(props.match.params.propertySlug), [], undefined);
    if (isLoading) {
        return <LoadingDisplay />;
    }
    const handleAskClick = () => {
        browserHistory.push(prospectPath(prospectPages.webTourFaq));
        return;
    };
    const backArrow = require('../../../../images/left-carot-small.png');
    return propertyData ? (
        <Container className="ask-page">
            <Row justify-content-center={true}>
                <Col xs={1} className="p-0 m-0">
                    <div className="back-button" onClick={browserHistory.goBack}>
                        <img src={backArrow} />
                    </div>
                </Col>
                <Col xs={10} className="p-0 m-0">
                    <h5>Need Help On the Tour?</h5>
                </Col>
            </Row>
            <Row justify-content-center={true}>
                <Col justify-content-center={true} align="center" xs={3}>
                    {' '}
                    <IconButton
                        icon={AskIcon}
                        addlButtonClassName="icon mt-4"
                        suppressBottomMargin={true}
                        onClick={handleAskClick}
                    />
                    <label
                        onClick={handleAskClick}
                        className="title center font-weight-bold icon-label"
                    >
                        FAQ
                    </label>
                </Col>
                <Col justify-content-center={true} align="center" xs={6}>
                    <a href={`tel:${tour24PhoneNumber}`}>
                        <IconButton
                            icon={PhoneIcon}
                            addlButtonClassName="icon mt-4"
                            suppressBottomMargin={true}
                        />
                        <label className="title center font-weight-bold icon-label">
                            {formatPhoneNumber(tour24PhoneNumber)}
                        </label>
                    </a>
                </Col>
                <Col justify-content-center={true} align="center" xs={3}>
                    <a href={`mailto:${tour24HelpEmail}`}>
                        <IconButton
                            icon={EmailIcon}
                            addlButtonClassName="icon mt-4"
                            suppressBottomMargin={true}
                        />
                        <label className="title center font-weight-bold icon-label">Email</label>
                    </a>
                </Col>
            </Row>
            <hr className="solid" />
            <Row justify-content-center={true} className="pt-3">
                <Col>
                    <h5>Ask A Live Agent</h5>
                </Col>
            </Row>
            <Row justify-content-center={true}>
                <Col>
                    <h5>About the Community</h5>
                </Col>
            </Row>
            <Row justify-content-center={true}>
                <Col className="justify-content-end" align="center">
                    <a href={`tel:${propertyData.contactPhone}`}>
                        <IconButton
                            icon={PhoneIcon}
                            addlButtonClassName="icon mt-4"
                            suppressBottomMargin={true}
                        />
                        <label className="title center font-weight-bold icon-label">
                            {formatPhoneNumber(propertyData.contactPhone)}
                        </label>
                    </a>
                </Col>
                <Col className="justify-content-start" align="center">
                    <a href={`mailto:${propertyData.contactEmail}`}>
                        <IconButton
                            icon={EmailIcon}
                            addlButtonClassName="icon mt-4"
                            suppressBottomMargin={true}
                        />
                        <label className="title center font-weight-bold icon-label">Email</label>
                    </a>
                </Col>
            </Row>
            <FormValidationDisplay errorMessage={errorMessage} />
        </Container>
    ) : (
        <LoadingDisplay />
    );
};

export default AskPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/AskPage.tsx